import React, { useState } from "react";
import { Typography, Grid, Box } from "@mui/material";
import BarComponent from "../components/BarComponent/BarComponent";
import SettingsWidget from "../components/SettingsWidget/SettingsWidget";
import AccountsWidget from "../components/AccountsWidget/AccountsWidget";
import { useAccelContext } from "../contexts/AccelContext/AccelContext";
import { useAccountContext } from "../contexts/AccountsContext/AccountsContext";

export const SettingsView = () => {
  const [toggle, setToggleType] = React.useState("linked_accounts");
  const [smartSuggestions, setSmartSuggestions] = useState(true);
  const [smartAssistant, setSmartAssistant] = useState(true);
  const [smartSummary, setSmartSummary] = useState(true);
  const [notificationFrequency, setNotificationFrequency] = useState("DAILY");
  const [accountingMethod, setAccountingMethod] = useState("ACCRUAL");
  const [fiscalYearStart, setFiscalYearStart] = useState(new Date());
  const [defaultCurrency, setDefaultCurrency] = useState("USD");
  const { theme, authErrorState} = useAccelContext();
  const { accounts } = useAccountContext();

  if (authErrorState) {
    return null; // or return <></> for an empty fragment
  }

  const values = [{ value: "linked_accounts", label: "Linked Accounts" }];

  const aiSettings = [
    {
      title: "Smart suggestions",
      description:
        "Employees can use AI-powered suggestions to fill in information for expenses.",
      isChecked: smartSuggestions,
      onToggle: setSmartSuggestions,
      type: "toggle",
      value: smartSuggestions,
    },
    {
      title: "Smart Assistant",
      description:
        "Assistant can take actions for employees, like automatically adding memos and attendees. Memo requirements determine when memos are auto-applied.",
      isChecked: smartAssistant,
      onToggle: setSmartAssistant,
      type: "toggle",
      value: smartAssistant,
    },
    {
      title: "Smart Summary",
      description:
        "Assistant will give AI memos of where spending can be improved and give alerts on irregular activities.",
      isChecked: smartSummary,
      onToggle: setSmartSummary,
      type: "toggle",
      value: smartSummary,
    },
  ];

  const notificationSettings = [
    {
      title: "Notification Frequency",
      description: "Set how often you want to receive notifications.",
      value: notificationFrequency,
      onChange: setNotificationFrequency,
      options: ["DAILY", "WEEKLY", "MONTHLY"],
      type: "select",
    },
  ];

  const accountingSettings = [
    {
      title: "Accounting Method",
      description: "Choose your preferred accounting method.",
      value: accountingMethod,
      onChange: setAccountingMethod,
      options: ["ACCRUAL", "CASH"],
      type: "select",
    },
    {
      title: "Fiscal Year Start",
      description: "Set the start date of your fiscal year.",
      value: fiscalYearStart,
      onChange: setFiscalYearStart,
      type: "date",
    },
    {
      title: "Default Currency",
      description: "Set your default currency.",
      value: defaultCurrency,
      onChange: setDefaultCurrency,
      type: "select",
      options: ["USD", "EUR", "GBP", "JPY"],
    },
  ];

  return (
    <Grid container spacing={2} sx={{ height: "100vh", width: "100vh" }}>
      <Grid
        item
        container
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
          flexDirection: "row",
        }}
        width="100%"
        spacing={2}
      >
        <Box sx={{ py: 1 }}>
          <Typography
            variant="h5"
            component="div"
            sx={{
              color: theme?.text?.hex,
              fontSize: 41,
              fontFamily: "Helvetica Neue",
            }}
          >
            Settings
          </Typography>
        </Box>
      </Grid>
      <Grid item width="100%">
        <BarComponent
          values={values}
          toggleType={toggle}
          setToggleType={setToggleType}
          showButtons={false}
          showToggleGroup={true}
        />
      </Grid>
      <Grid item width="100%">
        <Box
          sx={{
            minHeight: "700px",
            width: "100%",
            alignItems: "start",
          }}
        >
          {toggle === "linked_accounts" && <AccountsWidget />}
        </Box>
      </Grid>
    </Grid>
  );
};

export default SettingsView;
